import React from 'react';

export enum ButtonSize {
    STANDARD    = '36',
    SMALL       = '30',
    TINY        = '26'
}

export enum ButtonType {
    PRIMARY             = 'primary',
    SECONDARY           = 'secondary',
    SECONDARY_RED       = 'secondary_red',
    SECONDARY_DASHED    = 'secondary_dashed',
    ON_WHITE            = 'on-white',
    BUSY                = 'busy',
    GRAY                = 'gray',
    DISABLED            = 'disabled',
}

export type ButtonProps = {
    type?           : 'primary' | 'secondary' | 'busy' |'secondary-busy'|'disabled'|'on-white'|'on-gray'|'normal'| ButtonType | any,
    size            : ButtonSize | '36' | '30' | '26'
    disabled?       : boolean
    onClick?        : callback
    icon?           : string
    label?          : string

    iconPosition?   : 'left' | 'right'
    style?          : any
    className?      : string

    isPro?          : boolean

    href?            : string
    openNewWindow?  : boolean
}


export default class Button extends React.Component<ButtonProps,any> {

    static defaultProps = {
        isPro           : false,
        type            : ButtonType.PRIMARY,
        size            : ButtonSize.STANDARD, // ButtonSize.SMALL // WHY ????
        iconPosition    : 'left',
        disabled        : false
    }

    state = {
        type: this.props.type
    }

    componentDidUpdate(prevProps:any, prevState:any) {
        if(prevState.type !== this.props.type) {
            this.setState({
                type: this.props.type
            });
        }
    }

    setType(value:any) {
        if (['primary','normal','secondary','busy','disabled'].includes(value)) {
            this.setState({
                type: value
            });
        }
    }

    onClick = (e:React.SyntheticEvent) => {

        if (this.props.isPro && !gd.company.license.isPro) {
            e.preventDefault()
            e.stopPropagation()
            gd.modals.other.upgradeToPro()
            return false
        }

        if (['busy', 'disabled'].includes(this.state.type) || this.props.disabled) e.preventDefault();
        else if (this.props.onClick) this.props.onClick(e);
    }

    render() {
        // @ts-ignore
        const classes = Classes('ui5-button', 'flex', this.props.className, {
            's30'               : this.props.size === "30",
            's36'               : this.props.size === '36',
            's26'               : this.props.size === '26',
            'primary'           : this.state.type === 'primary',
            'secondary'         : this.state.type === 'secondary',
            'secondary-red'     : this.state.type === ButtonType.SECONDARY_RED,
            'secondary-dashed'  : this.state.type === ButtonType.SECONDARY_DASHED,
            'busy'              : this.state.type === 'busy',
            'secondary-busy'    : this.state.type === 'secondary-busy',
            'disabled'          : this.state.type === 'disabled' || this.props.disabled,
            'on-white'          : this.state.type === 'on-white',
            'on-gray'           : this.state.type === 'on-gray',
            'selected'          : this.state.type === 'selected',
            'with-icon'         : !!this.props.icon,
        });
        let buttonIcon = null;
        let buttonLabel : any = this.props.label;

        if (this.props.icon) {

            // @ts-ignore
            const iconClass = Classes("icon", this.props.icon, {
                'm-r-10'    : !!this.props.label && this.props.iconPosition === 'left',
                'm-l-10'    : !!this.props.label && this.props.iconPosition === 'right'
            })

            buttonIcon = <span key="icon" className={iconClass}/>
            buttonLabel = !!this.props.label && <span key="txt" className="txt">{this.props.label}</span>
        }

        if (this.state.type === 'busy') {
            buttonLabel = null;
            buttonIcon = <div className="ui5-busy-dots s8 color-action-to-pale"/>
        }

        if (this.state.type === 'secondary-busy') {
            buttonLabel = null;
            buttonIcon = <div className="ui5-busy-dots s8 color-pale-to-action"/>
        }

        let content;
        switch(this.props.iconPosition) {
            case 'left' : content = <React.Fragment>{buttonIcon}{buttonLabel}</React.Fragment>; break;
            case 'right': content = <React.Fragment>{buttonLabel}{buttonIcon}</React.Fragment>; break;
        }


        if (!this.props.href) {

            // this is button

            return (
                <div className={classes} onClick={this.onClick} style={this.props.style}>
                    {this.props.isPro && !gd.company.license.isPro && <div className="ui5-ico-pro s-28"/> }
                    {content}
                </div>
            )
        } else {

            // This is link
            let target = this.props.openNewWindow ? "_blank" : undefined

            return (
                <a className={classes} style={this.props.style} href={this.props.href} target={target} >
                    {this.props.isPro && !gd.company.license.isPro && <div className="ui5-ico-pro s-28"/> }
                    {content}
                </a>
            )
        }


    }
};
